import { useState } from "react";
import MaterialBox from "../../../../../components/MaterialBox";
import { Box, Card, Grid, Stack, Typography } from "@mui/material";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialSelect from "../../../../../components/MaterialSelect";
import MaterialInput from "../../../../../components/MaterialInput";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
export const ThirdComponent = ({
  meetingData,
  pages,
  masterData,
  setMeetingData,
  setActionItem
}) => {
  const [data, setData] = useState({
    startDate: "",
    endDate: "",
    items: "",
    assign: {},
    startDateStatus: "",
    endDateStatus: "",
    itemsStatus: "",
    assignStatus: "",
  });

  console.log(meetingData, 'meetingData')

  const [update, setUpdate] = useState(false);
  const [index, setIndex] = useState();

  const handelAssign = (event, selectEvent) => {
    let updatedData = { ...data };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "assign") {
        updatedData[selectEvent.name] = event;

        updatedData[selectEvent.name + "Status"] = event?.label?.trim()
          ? "success"
          : "error";
      }
    } else {
      const { name, value } = event.target;

      updatedData[name] = value;

      switch (name) {
        case "startDate":
          updatedData.startDateStatus = value ? "success" : "error";
          break;

        case "endDate":
          updatedData.endDateStatus = value ? "success" : "error";
          break;

        case "items":
          if (!value) {
            updatedData.itemsStatus = "error";
            setActionItem(false);
          } else if (value.trim().length < 10) {
            updatedData.itemsStatus = "error"; // Too short
            setActionItem(false);
          } else {
            updatedData.itemsStatus = "success";
            setActionItem(true);
          }
          break;

        default:
          break;
      }
    }
    setData(updatedData);
  };

  const handleSubmit = () => {
    setMeetingData((prev) => {
      let updatedMom = [...(prev?.mom || [])];

      if (
        update &&
        typeof index === "number" &&
        index >= 0 &&
        index < updatedMom.length
      ) {
        updatedMom[index] = data; // update existing
      } else {
        updatedMom = [...updatedMom, data]; // add new
      }

      return {
        ...prev,
        mom: updatedMom,
      };
    });

    // Reset the form fields
    setData({
      startDate: "",
      endDate: "",
      items: "",
      assign: {},
    });
    setActionItem(false);
  };

  // Delete point from summary
  const handleDelete = (index) => {
    const updated = [...(meetingData?.mom || [])];
    updated.splice(index, 1);
    setMeetingData((prev) => ({
      ...prev,
      mom: updated,
    }));
  };

  const handleEdit = (index) => {
    const itemToEdit = meetingData?.mom[index];
    setData((pre) => ({
      ...pre,
      startDate: itemToEdit?.startDate,
      endDate: itemToEdit?.endDate,
      items: itemToEdit?.items,
      assign: itemToEdit?.assign,
      assignStatus: "success",
      endDateStatus: "success",
      startDateStatus: "success",
      itemsStatus: "success",
    }));
    setUpdate(true);
    setIndex(index);
  };

  const disabledHandel = () => {
    let disabled;
    if (
      data?.assignStatus === "success" &&
      data?.endDateStatus === "success" &&
      data?.startDateStatus === "success" &&
      data?.itemsStatus === "success"
    ) {
      disabled = false;
    } else {
      disabled = true;
    }
    return disabled;
  };

  return (
    <div>
      <MaterialBox sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Start Date
              </MaterialTypography>
              <MaterialInput
               size="small"
                type="date"
                name="startDate"
                placeholder="Enter Employee Name"
                value={data?.startDate}
                onChange={handelAssign}
                error={data.startDateStatus === "error"}
                success={data.startDateStatus === "success"}
                disabled={pages.view}
              />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                End Date
              </MaterialTypography>
              <MaterialInput
               size="small"
                type="date"
                name="endDate"
                placeholder="Enter Employee Name"
                value={data?.endDate}
                onChange={handelAssign}
                error={data.endDateStatus === "error"}
                success={data.endDateStatus === "success"}
                disabled={pages.view}
              />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Assigne To
              </MaterialTypography>
              <MaterialSelect
               size="small"
                value={data?.assign}
                name="assign"
                onChange={handelAssign}
                options={meetingData?.participant}
                error={data?.assignStatus === "error"}
                success={data?.assignStatus === "success"}
                isDisabled={pages.view || meetingData?.participant?.length === 0}
              />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Add Action Items

              </MaterialTypography>
              <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <MaterialInput
                  size="small"
                  multiline
                  rows={2}
                  name="items"
                  placeholder="Enter Employee Name"
                  value={data?.items}
                  onChange={handelAssign}
                  error={data?.itemsStatus === "error"}
                  success={data?.itemsStatus === "success"}
                  disabled={pages.view}
                />
                <div style={{ alignContent: "center", textAlign: "center" }}>
                  <button
                    style={{
                      backgroundColor: "green",
                      border: "none",
                      borderRadius: "10%",
                      width: "80px",
                      height: "50px",
                      color: "white",
                      margin: "5px",
                      cursor: "pointer",
                      opacity: disabledHandel() ? "50%" : "100%",
                    }}
                    disabled={pages.view || disabledHandel()}
                    onClick={() => handleSubmit()}
                  >
                    {/* <div style={{ fontSize: "20px" }}>
                      <AddIcon />
                    </div> */}
                    Add item
                  </button>
                </div>
              </Box>
            </Stack>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ margin: "15px 0px" }}>
          {meetingData?.mom?.map((item, ind) => {
            return (
              <Grid size={{ xs: 12, md: 4 }}>
                <Card sx={{ padding: "15px", backgroundColor: "#fff", border: "1px dotted #93bcfbff", borderRadius: "15px" }}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h6>Task</h6>
                    {!pages?.view && (
                      <div>
                        <DeleteIcon
                          style={{
                            color: "red",
                            cursor: "pointer",
                            marginTop: "3px",
                          }}
                          onClick={() => handleDelete(ind)}
                          titleAccess="Delete"
                        />
                        <ModeEditIcon
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            marginTop: "3px",
                          }}
                          onClick={() => handleEdit(ind)}
                          titleAccess="Edit"
                        />
                      </div>
                    )}
                    {pages?.view && (
                      <div style={{display:'flex',alignContent:'center',padding:'5px',backgroundColor:'#144CA1',borderRadius:'5px'}}>
                        <Typography variant="caption" fontWeight='bold' color="#fff">{item?.status}</Typography>
                      </div>
                    )}


                  </div>
                  <p style={{ fontSize: "14px", color: "#0f5de2ff" }}>
                    {item?.items}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      fontSize: "14px",
                      justifyContent: "space-between",
                      margin: "5px",
                      fontWeight: "600",
                    }}
                  >
                    <p style={{ color: "#be42b2ff" }}>{item?.assign?.label}</p>
                    <p style={{ color: "#dc2329ff" }}>{item?.startDate}</p>
                    <p style={{ color: "#3cdb79ff" }}>{item?.endDate}</p>
                  </div>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </MaterialBox>
    </div>
  );
};
